{
    "icons":[
        {
            "name":"North Arrow",
            "url":"./assets/icons/north_arrow.png"
        },
        {
            "name":"Square",
            "url":"./assets/icons/square.png"
        },
        {
            "name":"Circle",
            "url":"./assets/icons/circle.png"
        },
        {
            "name":"Rectangle",
            "url":"./assets/icons/rectangle.png"
        }
    ]
}

